module.exports = __webpack_public_path__ + "images/hd_bg.png";